/**
 * 入力欄の文字列を、min〜max の整数に丸める
 * 範囲外の値を入力させないための変換で、数値にならない入力（文字・記号）は直前の値 fallback を保つ。
 * 空欄は Number('') が 0 になるため、0 を min〜max に丸めた値になる
 */
export const clampInteger = (value: string, min: number, max: number, fallback: number) => {
  const parsed = Number(value)
  if (!Number.isFinite(parsed)) {
    return fallback
  }

  return Math.min(max, Math.max(min, Math.floor(parsed)))
}
